var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"close-button",class:{
    'close-button_bordered': _vm.withBorder,
    'close-button_large': _vm.large
  },on:{"click":function($event){return _vm.$emit('click')}}},[_c('m-icon',{attrs:{"icon":_vm.iconCross}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }